
  <div class="modal-form modal-content" [class.hide]="!showModal">
    <div class="modal-header">
      <h5>Reopen the process</h5>
      <button class="close-modal-btn" (click)="modalRef.hide()"></button>
    </div>
    <div class="modal-body pt-0">
      <div class="deadline-change">
        <div class="caption">Expiration date</div>
        <div (click)="$event.stopPropagation()">
            <input type="text" #dt="bsDatepicker"
                bsDatepicker
                [(ngModel)]="endDate"
                [minDate]="currentDate"
                [bsConfig]="{ dateInputFormat: 'DD.MM.YYYY', containerClass:'deadline-change-calendar' }" />
            <i (click)="dt.toggle()" class="fa fa-calendar"></i>
        </div>
      </div>
      <div class="caption">Apply</div>
      <div class="col-8 p-0 d-flex apply-deadline-to">
          <div class="custom-control custom-radio p-0">
            <input (click)="selectAllToggleChanged(true)"  name="apply-deadline-to" id="for-all" type="radio" class="custom-control-input" />
            <label for="for-all" class="custom-control-label"> For all </label>
          </div>
          <div class="custom-control custom-radio p-0">
            <input (click)="selectAllToggleChanged(false)" checked name="apply-deadline-to" id="for-selected" type="radio" class="custom-control-input" />
            <label for="for-selected" class="custom-control-label"> For selected </label>
          </div>
      </div>
      <ng-container *ngIf="!isAllSelected">
        <div class="caption">Appraisee:</div>
        <div class="col-8 p-0 appraisee-selection">
            <ngx-select
                [allowClear]="true"
                [ngModel]="selected"
                [items]="appraiseesToSelect"
                (select)="onAppraiseeSelected($event)"
                optionTextField="name">
            </ngx-select>
        </div>
        <div class="d-flex selected-appraisee-container"  alwaysVisible="true" width="auto" height="130px" size="3px">
          <div *ngFor="let a of selectedAppraisees" class="selected-appraisee">
            <span>{{ a.name }}</span>
            <i  (click)="removeSelected(a)" class="ti-close cursor-pointer"></i>
          </div>
        </div>
      </ng-container>
    </div>
    <div class="modal-footer d-flex justify-content-end">
      <button class="cancel-btn" (click)="modalRef.hide()"> Cancel </button>
      <button (click)="onReopenClicked(approveModal)" class="reopen-process-btn"> Reopen process </button>
    </div>
  </div>
  <ng-template #approveModal>
    <div class="modal-form modal-content sub-modal">
      <app-spinner
      [isEnable]="isSpinnerEnable"
      loaderClass="reopen-process-loader">
    </app-spinner>
      <div class="modal-body">
          <button class="close-modal-btn" (click)="subModalRef.hide()"></button>
          <div class="d-flex justify-content-center flex-column" style="min-height: 90px;">
              <div>
                  Do you want to send notifications?
              </div>
          </div>
      </div>
      <div class="btn-modal">
          <span (click)="onNotificationSelect(true)">Yes</span>
          <span (click)="onNotificationSelect(false)">No</span>
      </div>
    </div>
  </ng-template>
